import translations from './translations.json';


export * from './components/RegistrationStep';
export * from './components/ContractorsRegistrationForm';
export * from './components/FactorinRegistrationForm';
export * from './components/DFARegistrationForm';

export const registration = {
    translations,
};
